import get from "lodash/get";
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';

import Skeleton from "../../../components/form/Skeleton"
import MapTrack from "../../../components/map/MapTrack";

import {
  GetDeliveryPointsById,
  ClearData
} from "../../../store/transactions/thunk/home";
import { Grid, Paper, Stack } from "@mui/material";


const Tracking = ({ setBtns, isEdit }) => {
  const [__] = useTranslation("global");
  const dispatch = useDispatch();
  const { id } = useParams();
  // console.log(id);

  const [r__] = useTranslation("order");
  const home = useSelector(state => state.transactions.home);
  const [preserveViewport, setPreserveViewport] = useState(false)
  // console.log(home);

  const getData = ({ page }) => {
    dispatch(GetDeliveryPointsById({ id: page }))
  }

  useEffect(() => {
    setBtns(
      <Stack className='mr-4' direction="row" spacing={1} justifyContent="flex-end">
      </Stack>
    )
  }, [isEdit])

  useEffect(() => {
    ClearData()
    getData({ page: Number(id) })
    setPreserveViewport(true)
  }, [dispatch])

  return (
    <Paper>

      <div  >
        {get(home, "isLoading")
          ? (
            <Skeleton />
          ) :

          (
            <Grid>
              <Paper className='mt-4 p-4 flex h-full flex-col' sx={{ height: 500 }}>
                <MapTrack
                  driverPosition={null}
                  locationSuggestions={get(home, "tracking.data.viewRouteDeliveryPoints", []) ?? []}
                  locationsReal={get(home, "tracking.data.viewOnRouteLocations", []) ?? []}
                  preserveViewport={false}
                />
              </Paper>
            </Grid>
          )
        }


      </div >
    </Paper>
  )
}

export default Tracking

